var map = {
	"./site-logo-desktop-footer.svg": 4888,
	"./site-logo-desktop.svg": 89180,
	"./site-logo-drawer-mobile.svg": 86210,
	"./site-logo-drawer.svg": 61603,
	"./site-logo-external.svg": 63529,
	"./site-logo-mobile-drawer.svg": 22116,
	"./site-logo-mobile.svg": 17842,
	"./site-logo-sm.svg": 48080,
	"./site-logo-tv.svg": 80838,
	"./site-logo-wrapper-mobile-scrolled.svg": 35021,
	"./site-logo-wrapper-mobile.svg": 47144,
	"./site-logo-wrapper-scrolled.svg": 97762,
	"./site-logo-wrapper.svg": 46573
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21703;